module.exports = __webpack_public_path__ + "img/oth11.e410d770.png";